import { render, staticRenderFns } from "./UserPackageDelivery.vue?vue&type=template&id=16b1b670&"
import script from "./UserPackageDelivery.vue?vue&type=script&lang=ts&"
export * from "./UserPackageDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./UserPackageDelivery.vue?vue&type=style&index=0&id=16b1b670&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports